import { Overline } from "@/components/shared/Primitives";

const Block = ({ id, title, children, testId }) => (
  <section data-testid={testId} className="border-t border-white/10 py-14 md:py-16">
    <div className="grid gap-6 md:grid-cols-[6rem_1fr] md:gap-12">
      <span className="font-mono text-xs tracking-[0.3em] text-[#D4AF37]">{id}</span>
      <div>
        <h2 className="font-display text-xl font-semibold uppercase tracking-[0.12em] text-[#F4F6FB] md:text-2xl">
          {title}
        </h2>
        <div className="mt-6 max-w-2xl">{children}</div>
      </div>
    </div>
  </section>
);

const Prose = ({ children, testId }) => (
  <p data-testid={testId} className="text-sm leading-relaxed text-[#F4F6FB]/65 md:text-base">
    {children}
  </p>
);

const Bullets = ({ items, testId, dot = "#8B5CF6" }) => (
  <ul data-testid={testId} className="space-y-4">
    {items.map((item) => (
      <li key={item} className="flex gap-3 text-sm leading-relaxed text-[#F4F6FB]/70 md:text-base">
        <span className="mt-2 h-1.5 w-1.5 shrink-0 rounded-full" style={{ background: dot }} />
        {item}
      </li>
    ))}
  </ul>
);

export const CaseStudyChapters = ({ project }) => {
  const s = project.sections;
  return (
    <div data-testid="case-study-chapters">
      <Block id="01" title="Challenge" testId="case-study-challenge">
        <Prose testId="case-study-challenge-text">{s.challenge}</Prose>
      </Block>
      <Block id="02" title="Idea" testId="case-study-idea">
        <Prose testId="case-study-idea-text">{s.idea}</Prose>
      </Block>
      <Block id="03" title="Experience" testId="case-study-experience">
        <Prose testId="case-study-experience-text">{s.experience}</Prose>
      </Block>
      <Block id="04" title="Design Direction" testId="case-study-design-direction">
        <Prose testId="case-study-design-direction-text">{s.designDirection}</Prose>
      </Block>
      <Block id="05" title="Technology" testId="case-study-technology">
        <Bullets items={s.technology} testId="case-study-technology-list" />
      </Block>
      <Block id="06" title="Process" testId="case-study-process">
        <Bullets items={s.process} testId="case-study-process-list" dot="#06B6D4" />
      </Block>
      <Block id="07" title="Outcome" testId="case-study-outcome">
        <Prose testId="case-study-outcome-text">{s.outcome}</Prose>
      </Block>
      <Block id="08" title="Deliverables" testId="case-study-deliverables">
        <Bullets items={project.deliverables} testId="case-study-deliverables-list" dot="#D4AF37" />
      </Block>
    </div>
  );
};

export const CaseStudyMeta = ({ project }) => (
  <aside
    data-testid="case-study-meta"
    className="rounded-2xl border border-white/10 bg-[#12141C]/45 p-8 backdrop-blur-xl lg:sticky lg:top-28 lg:self-start"
  >
    <Overline className="!text-[10px] !tracking-[0.35em]">Project</Overline>
    <dl className="mt-6 space-y-5">
      {[
        ["Capability", project.capability],
        ["Discipline", project.tag],
        ["Role", project.role],
        ["Year", project.year],
        ["Status", project.status],
      ].map(([label, value]) => (
        <div key={label}>
          <dt className="font-mono text-[10px] uppercase tracking-[0.3em] text-[#F4F6FB]/35">
            {label}
          </dt>
          <dd className="mt-1.5 text-sm text-[#F4F6FB]/80">{value}</dd>
        </div>
      ))}
    </dl>
  </aside>
);

export default CaseStudyChapters;
